import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';

import { trackAction } from '@ctct/distui-helpers';
import { Button, Dialog } from '@ctct/ui-react';

import SMSTiersTable from '../SMSTiersTable';

const SMSTierDialogV1 = ({
  t,
  open,
  closeDialog,
  initiallySelectedSMSTier,
  currency,
  SMSTiers,
  contactsCountLowEnd,
  saveSmsSelection,
  addSmsButtonText,
}) => {
  const [smsSelection, setSmsSelection] = useState(initiallySelectedSMSTier);

  useEffect(() => {
    trackAction({ action: 'sms-dialog-view' });
  }, []);

  // TODO add actual learn more URL @61
  return (
    <Dialog
      heading={t('sms-plans.name')}
      data-qe-id="sms-plans-dialog"
      contentFlush={false}
      kind="standard"
      isOpen={open}
      onDismiss={closeDialog}
    >
      <div>
        <header>
          <div className="content-left">{t('sms-plans.dialog.subtitle')}</div>
        </header>
        <div
          className="learn-more-about-sms"
          style={{
            display: 'flex',
            flexDirection: 'row-reverse',
            paddingBottom: 4,
            marginTop: -20,
          }}
        >
          <a
            href="https://knowledgebase.constantcontact.com/articles/KnowledgeBase/46517-Add-SMS-to-your-Constant-Contact-email-plan"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => {
              trackAction({ action: 'learn-more-select' });
            }}
          >
            {t('sms-plans.learn-more')}
          </a>
        </div>
        <div style={{ marginBottom: 20, overflow: 'auto' }}>
          <SMSTiersTable
            currency={currency}
            selectedSMSTier={smsSelection}
            setSelectedSMSTier={(min, max, price) => {
              trackAction({ action: 'tier-select' });
              setSmsSelection({ min, max, price });
            }}
            SMSTiers={SMSTiers}
            contactCountLowEnd={contactsCountLowEnd}
          />
        </div>
        <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
          <div>
            <Button
              block
              className="sidebar-continue-button"
              kind="primary"
              data-qe-id="sms-plans-dialog-continue-button"
              onClick={() => {
                trackAction({ action: 'add-sms-button-select' });
                saveSmsSelection(smsSelection);
                closeDialog();
              }}
              text={addSmsButtonText || t('sms-plans.add-sms')}
            />
          </div>
          <div style={{ marginRight: 20 }}>
            <Button
              block
              className="sidebar-continue-button"
              kind="secondary"
              data-qe-id="sms-plans-dialog-cancel-button"
              onClick={() => {
                setSmsSelection(initiallySelectedSMSTier);
                closeDialog();
              }}
              text={t('sms-plans.cancel')}
            />
          </div>
        </div>
      </div>
    </Dialog>
  );
};

SMSTierDialogV1.defaultProps = {
  contactsCountLowEnd: null,
  addSmsButtonText: null,
};

SMSTierDialogV1.propTypes = {
  t: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  closeDialog: PropTypes.func.isRequired,
  saveSmsSelection: PropTypes.func.isRequired,
  currency: PropTypes.string.isRequired,
  initiallySelectedSMSTier: PropTypes.shape({
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    price: PropTypes.number.isRequired,
  }).isRequired,
  SMSTiers: PropTypes.arrayOf(
    PropTypes.shape({
      tierMin: PropTypes.number.isRequired,
      tierMax: PropTypes.number.isRequired,
      price: PropTypes.number.isRequired,
    })
  ).isRequired,
  contactsCountLowEnd: PropTypes.number,
  addSmsButtonText: PropTypes.string,
};

export default withTranslation()(SMSTierDialogV1);
